import getMediaElement from 'editor/src/store/design/selector/getMediaElement';
import { updateMediaElementAction } from 'editor/src/store/design/slice';
import { ElementAddress, MediaImage } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';
import {
  AdvancedPersonalisationElementData,
  buildAdvPersoPluginsUpdate,
  getAdvPersoDataFromElement,
} from 'editor/src/store/plugins/utils/advPersoUtils';

// Sets (or clears) a dropdown label override for one asset of a collection element. An empty
// label, or one matching the asset's own name, removes the override so display falls back to the
// asset name; the assetLabels map itself is dropped from the plugin data once it becomes empty.
const setCollectionAssetLabelOperation =
  (elementAddress: ElementAddress, assetId: string, label: string, assetName: string) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const element = getMediaElement<MediaImage>(getState(), elementAddress);
    const data = element && getAdvPersoDataFromElement(element);
    if (!element || !data) {
      return;
    }

    const trimmed = label.trim();
    const assetLabels = { ...data.assetLabels };
    if (!trimmed || trimmed === assetName) {
      delete assetLabels[assetId]; // no override -> fall back to the asset name
    } else {
      assetLabels[assetId] = trimmed;
    }

    const nextData: AdvancedPersonalisationElementData = { ...data, assetLabels };
    if (Object.keys(assetLabels).length === 0) {
      delete nextData.assetLabels;
    }

    dispatch(
      updateMediaElementAction({
        elementAddress,
        elementUpdate: { plugins: buildAdvPersoPluginsUpdate(element, nextData) },
      }),
    );
  };

export default setCollectionAssetLabelOperation;
